import { render } from "./SelectOnlyButton.vue?vue&type=template&id=1829107c"
import script from "./SelectOnlyButton.vue?vue&type=script&lang=js"
export * from "./SelectOnlyButton.vue?vue&type=script&lang=js"

import "./SelectOnlyButton.vue?vue&type=style&index=0&id=1829107c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__